var render = function render(){var _vm=this,_c=_vm._self._c;return _c('back-to-top',_vm._b({},'back-to-top',_vm.backToTopProps,false),[_c('button',{staticClass:"btn icon secondary rounded",attrs:{"type":"button"}},[_c('inline-svg',{attrs:{"src":"/img/icons/to-top.svg"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }